import React from "react";
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import { useEffect, useState } from "react";
import { authenticationService } from "../../services";
import { AppBarCenter, LogoText, useStyles, MenuLink } from "./MainPageStyles";
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { BackgroundCurve, ContentCurve } from "./Page";
import Footer from "../Footer/Footer";
import { Divider, List } from "@material-ui/core";
import { ElectricityCostPath } from "../../pages/ElectricityCost";
import FlashOnIcon from '@material-ui/icons/FlashOn';
import InstyleMenuItem from '../Menu/InstyleMenuItem';
import { SavingEstimatePath } from "../../pages/SavingsEstimate";
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import { SiteBuilderPath } from "../../pages/SiteBuilder";
import BuildIcon from '@material-ui/icons/Build';
import { AddonsPath } from "../../pages/Addons";
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import { PricingTermPath } from "../../pages/PricingTerm";
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import FloatingNext from "./FloatingNext";
import { useLocation } from "react-router";

function Page (props) {
  const [ loggedIn, setLoggedIn ] = useState(authenticationService.currentUserValue);
  const location = useLocation()

  const theme = useTheme();
  const classes = useStyles(theme);

  const [open, setOpen] = React.useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };


  useEffect(() => {
    authenticationService.currentUser.subscribe(x => {
      setLoggedIn(authenticationService.currentUserValue);
    });
  });

  return (
    <>
      {loggedIn ?
      <LoggedInPage/>
      :
      <LoggedOutPage/>}
    </>
  );


  function LoggedInPage() {
    return (
      <div className={classes.root}>
        <FloatingNext />
        <AppBar
          position="fixed"
          className={clsx(classes.instyleAppBar, {
            [classes.instyleAppBarShift]: open,
          })}
          >
          <Toolbar>
            {
              !open && <IconButton edge="start" color="inherit" aria-label="menu" onClick={() => setOpen(true)}>
                          <MenuIcon />
                      </IconButton>
            }
            <AppBarCenter >
              <a href="/" style={{color: 'white'}}><LogoText>Sales</LogoText> by Instyle Solar</a>
            </AppBarCenter>
          </Toolbar>
        </AppBar>
        <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton style={{color: "var(--color-white)"}} onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </div>
        <Divider style={{backgroundColor: "var(--color-white)"}} />
        <List>
          <InstyleMenuItem to={ElectricityCostPath} location={location} label="1. Electricity Costs" icon={<FlashOnIcon />} />
          <InstyleMenuItem to={SavingEstimatePath} location={location} label="2. Savings Estimate" icon={<AttachMoneyIcon />} />
          <InstyleMenuItem to={SiteBuilderPath} location={location} label="3. Site Builder" icon={<BuildIcon />} />
          <InstyleMenuItem to={AddonsPath} location={location} label="4. Addons" icon={<AddShoppingCartIcon />} />
          <InstyleMenuItem to={PricingTermPath} location={location} label="5. Pricing Term" icon={<LocalAtmIcon />} />
        </List>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        { BackgroundCurve() }
        <div style={{position: 'relative', height: '100%', overflowX: 'scroll'}}>
        { props.children }
        </div>

        { ContentCurve() }
      </main>
      <Footer />
      </div>
    )
  }

  function LoggedOutPage() {
    return (
      <div className={classes.root}>
        <AppBar
          position="fixed"
          className={clsx(classes.instyleAppBar, {
            [classes.instyleAppBarShift]: open,
          })}
          >
          <Toolbar>
            <AppBarCenter >
              <LogoText>Sales</LogoText> by Instyle Solar
            </AppBarCenter>
          </Toolbar>
        </AppBar>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        { BackgroundCurve() }
        { props.children }

        { ContentCurve() }
      </main>
      <Footer />
      </div>
    )
  }
}

export default Page;
